import { Skeleton, SkeletonText, Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { GoTop } from '../../../../app/components/GoTop';
import { usePublicOffer } from '../hooks/usePublicOffer';
import './PublicOfferPage.scss';

const PublicOfferPage = () => {
  const { t } = useTranslation();
  const { offer, isLoading } = usePublicOffer();

  if (isLoading) {
    return (
      <Stack className='public-offer' spacing={4}>
        <Skeleton height='40px' width='260px' />
        <SkeletonText noOfLines={8} spacing={4} skeletonHeight='4' />
      </Stack>
    );
  }

  return (
    <>
      <section className='public-offer'>
        <h1 className='public-offer__title'>
          {offer?.title || t('footer.public_offer')}
        </h1>
        {offer?.content ? (
          <div
            className='public-offer__body'
            dangerouslySetInnerHTML={{ __html: offer.content }}
          />
        ) : (
          <p className='public-offer__empty'>{t('legal.public_offer_empty')}</p>
        )}
      </section>
      <GoTop />
    </>
  );
};

export default PublicOfferPage;
